import { createContext } from "react";

/** Whose portrait the page shows and changes: the caller's or, for admins, a colleague's */
export const PortraitSubjectContext = createContext({
  apiPath: "/api/portrait",
});

export const colleaguesPortrait = (uidNumber: number) => ({
  apiPath: `/api/admin/portraits/${uidNumber}`,
});
